/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";

// Redux
import "./AgentsTableHeadButton.scss";


const index = (props) => {
  return (
    <button className="visualization-buttons" onClick={props.onClick}>
      {props.icon === "group-view-ico" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <g fill="none" fillRule="evenodd">
            <g
              fill={
                props.isDark
                  ? props.isActive
                    ? "#F8F8FB"
                    : "#74788D"
                  : props.isActive
                  ? "#556ee6"
                  : "#a7b0cf"
              }
            >
              <g>
                <g>
                  <path
                    d="M7.111 1.281C7.111.574 6.538 0 5.83 0H1.281C.574 0 0 .574 0 1.281V5.83c0 .708.574 1.281 1.281 1.281H5.83c.708 0 1.281-.573 1.281-1.281V1.281zM16 1.281C16 .574 15.426 0 14.72 0H10.17c-.707 0-1.281.574-1.281 1.281V5.83c0 .708.574 1.281 1.281 1.281h4.549c.707 0 1.281-.573 1.281-1.281V1.281zM7.111 10.17c0-.708-.573-1.281-1.281-1.281H1.281C.574 8.889 0 9.462 0 10.169v4.55C0 15.426.574 16 1.281 16H5.83c.708 0 1.281-.574 1.281-1.281v-4.55zM16 10.17c0-.708-.574-1.281-1.281-1.281H10.17c-.707 0-1.281.573-1.281 1.28v4.55c0 .707.574 1.281 1.281 1.281h4.549c.707 0 1.281-.574 1.281-1.281v-4.55z"
                    transform="translate(-1808 -735) translate(1808 735)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="14"
          viewBox="0 0 16 14"
        >
          <g fill="none" fillRule="evenodd">
            <g
              fill={
                props.isDark
                  ? props.isActive
                    ? "#F8F8FB"
                    : "#74788D"
                  : props.isActive
                  ? "#808080"
                  : "#a7b0cf"
              }
            >
              <g>
                <g>
                  <path
                    d="M3.06 1.53c0 .845-.685 1.53-1.53 1.53S0 2.375 0 1.53.685 0 1.53 0s1.53.685 1.53 1.53M3.06 6.885c0 .845-.685 1.53-1.53 1.53S0 7.73 0 6.885s.685-1.53 1.53-1.53 1.53.685 1.53 1.53M3.06 12.24c0 .845-.685 1.53-1.53 1.53S0 13.085 0 12.24s.685-1.53 1.53-1.53 1.53.685 1.53 1.53M6.12 2.295h8.415c.423 0 .765-.342.765-.765s-.342-.765-.765-.765H6.12c-.423 0-.765.342-.765.765s.342.765.765.765zM14.535 6.12H6.12c-.423 0-.765.342-.765.765s.342.765.765.765h8.415c.423 0 .765-.342.765-.765s-.342-.765-.765-.765zM14.535 11.475H6.12c-.423 0-.765.342-.765.765s.342.765.765.765h8.415c.423 0 .765-.342.765-.765s-.342-.765-.765-.765z"
                    transform="translate(-1842 -737) translate(1808 735) translate(34 2)"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      )}
    </button>
  );
};

export default index;
